module.exports = __webpack_public_path__ + "img/Z86Q_18.7893d4fe.jpg";